import { storesNode, couriersNode } from '@/api/firebase'
import { Connection } from 'verda-web-internals'

/*
 *  Abbreviations:
 *      User - User
 *      Cour - Courier
 *      Ctn - Connection
 *      Str - Store
 *      Ordr - Order
 *      Rdy - Ready
 *      Pckd - Picked Up
 *      Delv - Delivered
 *      Cncl - Canceled
 */

// Courier Connections
export const StrCtn = new Connection(storesNode)
export const CourCtn = new Connection(couriersNode)
